"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestHeaders = void 0;
const guid_utils_1 = require("./guid.utils");
class RequestHeaders {
    static compose(additionalHeaders) {
        if (!additionalHeaders) {
            return RequestHeaders.baseHttpHeaders;
        }
        return Object.assign(Object.assign({}, RequestHeaders.baseHttpHeaders), additionalHeaders);
    }
}
exports.RequestHeaders = RequestHeaders;
RequestHeaders.baseHttpHeaders = {
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Origin': '*',
    'Api-Version': 'v1',
    'Content-Type': 'application/json; charset=utf-8',
    'Correlation-Id': guid_utils_1.Guid.newGuid(),
};
//# sourceMappingURL=request-headers.utils.js.map